import { useAxios } from "../../service-axios";

// https://www.folkstalk.com/2022/09/how-to-decode-jwt-token-client-side-with-code-examples.html
// TODO: see if there is a better way....
const b64DecodeUnicode = (str) =>
  decodeURIComponent(
    Array.prototype.map
      .call(
        atob(str),
        (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      )
      .join("")
  );

const parseJwt = (token) =>
  JSON.parse(
    b64DecodeUnicode(token.split(".")[1].replace("-", "+").replace("_", "/"))
  );

export const useServiceLogin = () => {
  const { axios } = useAxios();

  const validate = async (token) => {
    const res = await axios.post(
      `loginApi://v1/token/refresh`,
      {},
      {
        headers: { "x-refresh-token": token }
      }
    );
    return res.data;
  };

  const introspect = async (token) => parseJwt(token);

  const verify = async (token) => {
    await axios.post(`loginApi://v1/token/verify`, {});
    return parseJwt(token);
  };

  const refresh = async () => {
    const res = await axios.post("loginApi://v1/token/refresh", {});
    const { applicationToken } = res.data;
    return applicationToken;
  };

  return {
    validate,
    introspect,
    verify,
    refresh
  };
};
